import React, {useCallback, useLayoutEffect, useMemo, useState} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import {useSearchParams} from 'react-router-dom'
import useQueryWithdrawDetail from '../../hooks/api/withdraw/useQueryWithdrawDetail'
import Text from '../../components/text/Text'
import useQueryUserDetail from '../../hooks/api/user/useQueryUserDetail'
import WizImage from '../../components/image/WizImage'
import {useImage} from '../../utils/image'
import Span from '../../components/text/Span'
import WizButton from '../../components/button/WizButton'
import {useTime} from '../../utils/time'
import {JsonView} from 'react-json-view-lite'
import useQueryWithdrawTransaction from '../../hooks/api/withdraw/useQueryWithdrawTransaction'
import {copyToClipboard, useTag} from '../../utils/etc'
import useNavigation from '../../hooks/useNavigation'
import TableHeader from '../../components/table/TableHeader'
import {useDisplayNumber} from '../../utils/number'
import {postApprove} from '../../apis/withdraw/approve'
import ic_warning from '../../assets/images/ic_warning_circle_red.png'
import {withdrawPostRetry} from '../../apis/withdraw/retry'

interface IProps {
    className?: string
}

const WithdrawDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const keyId = searchParams.get('id')
    const status = searchParams.get('status')

    const [unAble, setUnAble] = useState(false)
    const [isOpenApproveModal, setIsOpenApproveModal] = useState(false)
    const [isOpenRetryModal, setIsOpenRetryModal] = useState(false)
    const [privateKey, setPrivateKey] = useState('')
    const {data, refetch} = useQueryWithdrawDetail(keyId)

    const withdrawData = useMemo(() => {
        return data?.data
    }, [data])

    const {data: userData, refetch: userRefetch} = useQueryUserDetail(withdrawData?.user_id)

    const {data: transactionData, refetch: transactionRefetchj} = useQueryWithdrawTransaction(withdrawData?.user_id)

    const {renderThumbnail} = useImage()
    const {convertUtc0ToUtc9} = useTime()
    const {renderStatusTagColor} = useTag()
    const {floorBalance} = useDisplayNumber()
    const {goUserDetail} = useNavigation()

    const onChangeApproveKey = e => {
        setPrivateKey(e)
    }

    const delay = ms => new Promise(res => setTimeout(res, ms))

    const onClickApprove = useCallback(async () => {
        try {
            const res = await postApprove(keyId, privateKey)
            if (res.data.error !== undefined) {
                alert('Withdraw Approve Failed!')
                throw new Error('인증에 실패 하였습니다. :', res.data.err)
            } else {
                alert('Withdraw Approve Success')
                window.location.reload()
            }
        } catch (err) {
            alert(err.message)
        } finally {
            await delay(1000)
            refetch()
        }
    }, [privateKey])

    const retryWithdraw = async () => {
        try {
            const res = await withdrawPostRetry(keyId)
            if (res.data.error !== undefined) {
                alert('Withdraw Retry Failed!')
                throw new Error('재시도 실패. :', res.data.err)
            } else {
                alert('Withdraw Retry Success')
                window.location.reload()
            }
        } catch (err) {
            alert(err.message)
        } finally {
            await delay(1000)
            refetch()
        }
    }

    const onClickApproveModal = () => {
        setIsOpenApproveModal(true)
    }

    const onClickRetryModal = () => {
        setIsOpenRetryModal(true)
    }

    useLayoutEffect(() => {
        if (data?.data?.approval_signature !== '') {
            setUnAble(true)
        } else {
            setUnAble(false)
        }
    }, [data])

    return (
        <PageLayout title={'Withdraw Detail'}>
            <div className={'grid grid-cols-2 gap-x-[30px] md:block'}>
                <div className={'bg-white rounded-[10px] p-[30px] shadow-normal flex items-center self-start lg:block'}>
                    <div className={'flex-1'}>
                        <Text className={'text-h4'}>User Info</Text>
                        <div className={'mt-[20px] flex items-center gap-x-[10px]'}>
                            <WizImage
                                src={renderThumbnail(userData?.thumbnail)}
                                className={'w-[40px] h-[40px] rounded-full'}
                            />
                            <Text
                                className={'cursor-pointer'}
                                onClick={() => {
                                    copyToClipboard(userData?.id)
                                }}>
                                <Span className={'text-h3 md:block'}>{userData?.name}</Span>
                                <Span className={'text-ti2'}>
                                    {userData?.nicknames?.length > 0 ? `(${userData?.nicknames?.at(0)?.nickname})` : ''}
                                </Span>
                            </Text>
                        </div>
                        <Text
                            onClick={() => {
                                copyToClipboard(userData?.id)
                            }}
                            className={'text-body3 text-font02 mt-[5px] cursor-pointer'}>
                            ({withdrawData?.user_id})
                        </Text>
                    </div>
                    <div className={'lg:mt-[20px]'}>
                        <WizButton
                            text={'Go User Portfolio'}
                            onClick={() => {
                                goUserDetail(withdrawData?.user_id)
                            }}
                            type={'blue'}
                        />
                    </div>
                </div>
                <div className={'bg-white rounded-[10px] p-[30px] shadow-normal md:mt-[30px]'}>
                    <Text className={'text-h4'}>Approve Withdraw</Text>
                    <textarea
                        value={privateKey}
                        onChange={e => {
                            onChangeApproveKey(e?.target?.value)
                        }}
                        className={
                            'mt-[20px] border bg-white relative w-full text-body2 rounded-[5px] px-[20px] py-[30px] border-line02 resize-none min-h-[120px] focus:border-primary'
                        }
                        disabled={unAble}
                        placeholder={'Input Your Private Key'}
                    />
                    <Text className={`${unAble ? 'block' : 'hidden'} text-font_red mt-[10px]`}>
                        출금을 실행 할 수 없습니다.
                    </Text>
                    <div className={'mt-[20px] flex items-center gap-x-[10px]'}>
                        {status === 'failed' && (
                            <WizButton text={'Retry'} type={'red'} onClick={() => onClickRetryModal()} />
                        )}
                        <WizButton
                            text={'Approve'}
                            onClick={() => onClickApproveModal()}
                            disabled={unAble}
                            type={'primary'}
                        />
                    </div>
                </div>
            </div>
            <div className={'bg-white rounded-[10px] p-[30px] mt-[30px] shadow-normal'}>
                <Text className={'text-h4'}>Withdraw infomation</Text>
                <div className={'mt-[30px] grid grid-cols-2 gap-x-[20px] gap-y-[20px] sm:grid-cols-1'}>
                    <div>
                        <Text className={'text-ti2 text-font02'}>Amount</Text>
                        <Text>{withdrawData?.amount}</Text>
                    </div>
                    <div>
                        <Text className={`text-ti2 text-font02`}>Status</Text>
                        <Text className={`${renderStatusTagColor(withdrawData?.status)}`}>{withdrawData?.status}</Text>
                    </div>
                    <div>
                        <Text className={'text-ti2 text-font02'}>Network</Text>
                        <Text>{withdrawData?.blockchain}</Text>
                    </div>
                    <div>
                        <Text className={'text-ti2 text-font02'}>Fee</Text>
                        <Text>{withdrawData?.fee}</Text>
                    </div>
                    <div>
                        <Text className={'text-ti2 text-font02'}>Address</Text>
                        <Text className={'break-all'}>{withdrawData?.address}</Text>
                    </div>
                    <div>
                        <Text className={'text-ti2 text-font02'}>IP</Text>
                        <Text>{withdrawData?.ip}</Text>
                    </div>
                    <div>
                        <Text className={'text-ti2 text-font02'}>Move to Payment Server</Text>
                        <Text className={`${withdrawData?.moved ? '' : 'text-font_red'}`}>
                            {withdrawData?.moved ? 'Payment to Server' : 'Not Payment to Server'}
                        </Text>
                    </div>
                    <div>
                        <Text className={'text-ti2 text-font02'}>Creat At</Text>
                        <Text>{convertUtc0ToUtc9(Number(withdrawData?.created_at) * 1000)}</Text>
                    </div>
                </div>
            </div>
            <div className={'bg-white rounded-[10px] p-[30px] mt-[30px] shadow-normal'}>
                <Text className={'text-h4'}>Transaction History</Text>
                <div className={'mt-[30px]'}>
                    <TableHeader className={'grid grid-cols-7 md:grid-cols-5 mb-[10px] px-[10px] sm:hidden'}>
                        <div className={'col-span-2 md:col-span-1'}>
                            <Text>Action</Text>
                        </div>
                        <div className={'text-right'}>
                            <Text>Amount</Text>
                        </div>
                        <div className={'text-right'}>
                            <Text>Balance After</Text>
                        </div>
                        <div className={' md:hidden'}>
                            <Text className={'text-center'}>Coin</Text>
                        </div>
                        <div className={'col-span-2'}>
                            <Text className={'text-right'}>Time</Text>
                        </div>
                    </TableHeader>
                    {transactionData?.data?.map(list => (
                        <div
                            key={list?.id}
                            className={
                                'grid grid-cols-7 md:grid-cols-5 px-[10px] py-[20px] sm:block sm:border-b sm:border-b-line02'
                            }>
                            <Text className={'text-ti2 col-span-2 md:col-span-1 sm:pb-[10px]'}>{list?.action}</Text>
                            <Text className={'text-right text-font02 sm:text-left sm:text-body3'}>
                                <Span className={'hidden sm:block sm:text-body3'}>Amount : </Span>
                                {floorBalance(list?.amount, 1000)}
                            </Text>
                            <Text className={'text-right text-font02 sm:text-left sm:text-body3'}>
                                <Span className={'hidden sm:block sm:text-body3'}>Balance After : </Span>
                                {floorBalance(list?.balance_after, 1000)}
                            </Text>
                            <Text className={'text-center text-font02 md:hidden sm:block sm:text-left sm:text-body3'}>
                                <Span className={'hidden sm:block sm:text-body3'}>Coin : </Span>
                                {list?.coin}
                            </Text>
                            <Text className={'text-right text-font03 col-span-2 sm:pt-[10px] sm:text-body3'}>
                                {convertUtc0ToUtc9(list?.created_at)}
                            </Text>
                        </div>
                    ))}
                </div>
            </div>
            <div className={'bg-white rounded-[10px] p-[30px] mt-[30px] shadow-normal'}>
                <Text>Response Viewer</Text>
                {data ? (
                    <JsonView
                        data={data}
                        style={{
                            basicChildStyle: 'w-full break-all text-body2',
                            booleanValue: 'text-gray-400',
                            container: '',
                            expander: '',
                            label: 'text-font02',
                            nullValue: 'text-red-500',
                            numberValue: 'text-alt_blue',
                            otherValue: '',
                            pointer: '',
                            punctuation: '',
                            stringValue: 'text-font_green',
                            undefinedValue: 'text-orange-500',
                        }}
                    />
                ) : (
                    <></>
                )}
            </div>
            {isOpenApproveModal && (
                <div>
                    <div
                        onClick={() => setIsOpenApproveModal(false)}
                        className={'fixed top-0 left-0 w-full h-full bg-black opacity-30 cursor-pointer z-[3]'}
                    />
                    <div
                        className={
                            'fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[350px] h-min bg-white rounded-[10px] p-[30px] z-[4] shadow-hover'
                        }>
                        <WizImage src={ic_warning} className={'w-[30px] mx-auto'} />
                        <Text className={'text-h4 text-center mt-[5px]'}>정말 출금을 진행하시겠습니까?</Text>
                        <Text className={'mt-[10px] text-center'}>출금을 진행하면 절대로 멈출 수 없습니다. </Text>
                        <div className={'flex mx-auto gap-x-[10px] mt-[20px] justify-center'}>
                            <WizButton text={'Cancel'} type={'gray'} onClick={() => setIsOpenApproveModal(false)} />
                            <WizButton
                                text={'Approve'}
                                type={'red'}
                                onClick={() => {
                                    onClickApprove()
                                    setIsOpenApproveModal(false)
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}

            {isOpenRetryModal && (
                <div>
                    <div
                        onClick={() => setIsOpenRetryModal(false)}
                        className={'fixed top-0 left-0 w-full h-full bg-black opacity-30 cursor-pointer z-[3]'}
                    />
                    <div
                        className={
                            'fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[350px] h-min bg-white rounded-[10px] p-[30px] z-[4] shadow-hover'
                        }>
                        <WizImage src={ic_warning} className={'w-[30px] mx-auto'} />
                        <Text className={'text-h4 text-center mt-[5px]'}>정말 출금을 재시도하시겠습니까?</Text>
                        <Text className={'mt-[10px] text-center'}>재시도를 진행하면 절대로 멈출 수 없습니다. </Text>
                        <div className={'flex mx-auto gap-x-[10px] mt-[20px] justify-center'}>
                            <WizButton text={'Cancel'} type={'gray'} onClick={() => setIsOpenRetryModal(false)} />
                            <WizButton
                                text={'Retry'}
                                type={'red'}
                                onClick={async () => {
                                    await retryWithdraw()
                                    setIsOpenApproveModal(false)
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </PageLayout>
    )
}

export default WithdrawDetailPage
